import { CustomFile } from "../../../Helpers/file";
import {
    ExcelsToPartialFufsResponse,
    FileProperties,
} from "../../../../../Common/CandyApiClient/Types/DraftActions/FileProperties";
import {
    FufCombineMethod,
    CombineFufResult,
    CombinatorType,
} from "../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";

export enum UploadFormTypes {
    "default",
    "NDS",
}

export interface UploadFileOptions {
    formType: UploadFormTypes;
    declarationGfv: string;
    requestedGfv?: string;
}

export interface IFufManager {
    addFile(
        file: CustomFile,
        ignoreSizeCheck?: boolean,
        skipUploadFile?: boolean,
        uploadFileOptions?: UploadFileOptions
    ): Promise<FileProperties | undefined>;
    prepareAndAddFile(file: CustomFile, gfv: string): Promise<FileProperties | undefined>;
    getFufExpectedDemandFileName(): Promise<string | undefined>;
    setFuf(driveUri: string): Promise<void>;
    excelsToPartialFufs(
        gfv: string,
        pathToTable: string,
        driveUris: string[]
    ): Promise<ExcelsToPartialFufsResponse | undefined>;
    importXmls(
        driveUris: string[],
        combineMethod: FufCombineMethod,
        combinatorType: CombinatorType,
        isImportByFuf: boolean,
        args?: string[]
    ): Promise<CombineFufResult | undefined>;
}
